/**
 * BF2142 Display-Name-Mappings (Issue #13).
 *
 * Engine-Template-Codes (RCON `bf2cc pl` Feld 38 = Fahrzeug, sowie Waffen-Codes)
 * -> lesbare Anzeigenamen. Quelle: kuratierte Projekt-Mappings (1:1 übernommen).
 *
 * Bewusst getrennt nach `vehicles` und `weapons`. Für Slice B (Issue #13) wird
 * NUR `vehicles` in der UI verwendet (Players Tactical Map). `weapons` ist hier
 * vorbereitet/exportiert, aber noch NICHT an UI-Stellen verdrahtet.
 *
 * Konventionen:
 * - Mehrere Engine-Keys können auf denselben Anzeigenamen zeigen (Sitz-/Turm-/
 *   Spawn-Positionen desselben Fahrzeugs).
 * - Ein **leerer** Mapping-Wert (`""`) bedeutet "bewusst nichts anzeigen" (z. B.
 *   reine Soldaten-/Passagier-Positionen) — das ist NICHT dasselbe wie "Key
 *   fehlt" (dann greift der Roh-Fallback beim Aufrufer).
 */

/** Fahrzeug-/Asset-Codes (Feld 38) -> Anzeigename. */
export const VEHICLE_DISPLAY_NAMES: Record<string, string> = {
  us_ag: "UD-6 Talon",
  us_ag_tad: "UD-6 Talon",
  eu_gunship: "UD-6 Talon",
  eu_gunship_mg: "UD-6 Talon - Mg.",
  eu_gunship_missile: "UD-6 Talon - Missile",

  as_ag: "Type 4 Doragon",
  as_secondposition: "Type 4 Doragon",
  as_gunship: "Type 4 Doragon",
  as_gunship_mg: "Type 4 Doragon - Mg.",
  as_gunship_missile: "Type 4 Doragon - Missile",

  eu_at: "UD-12 Shepherd",
  eu_at_spawn: "UD-12 Shepherd",
  eu_at_l_gunner: "UD-12 Shepherd",
  eu_at_l_gunner_spawn: "UD-12 Shepherd",
  eu_at_r_gunner: "UD-12 Shepherd",
  eu_at_r_gunner_spawn: "UD-12 Shepherd",
  eu_at_passenger3_left: "UD-12 Shepherd",
  eu_at_passenger3_left_spawn: "UD-12 Shepherd",
  eu_at_passenger3_right: "UD-12 Shepherd",
  eu_at_passenger3_right_spawn: "UD-12 Shepherd",
  eu_transport: "UD-12 Shepherd",
  eu_transport_mg: "UD-12 Shepherd - Mg.",

  as_at: "BTR-20 Yastreb",
  as_at_spawn: "BTR-20 Yastreb",
  as_at_second_pos: "BTR-20 Yastreb",
  as_at_second_pos_spawn: "BTR-20 Yastreb",
  as_at_third_pos: "BTR-20 Yastreb",
  as_at_third_pos_spawn: "BTR-20 Yastreb",
  as_at_passenger3_left: "BTR-20 Yastreb",
  as_at_passenger3_left_spawn: "BTR-20 Yastreb",
  as_at_passenger3_right: "BTR-20 Yastreb",
  as_at_passenger3_right_spawn: "BTR-20 Yastreb",
  as_transport: "BTR-20 Yastreb",
  as_transport_mg: "BTR-20 Yastreb - Mg.",

  eu_apc: "AMV-2 Groundhog",
  eu_apc_second_turret: "AMV-2 Groundhog",
  eu_apc_podcannon1: "AMV-2 Groundhog",
  eu_apc_podcannon2: "AMV-2 Groundhog",
  eu_apc_podcannon3: "AMV-2 Groundhog",
  eu_apc_podcannon4: "AMV-2 Groundhog",
  eu_apc_alps: "AMV-2 Groundhog",
  eu_apc_podcannon1_alps: "AMV-2 Groundhog",
  eu_apc_podcannon2_alps: "AMV-2 Groundhog",
  eu_apc_podcannon3_alps: "AMV-2 Groundhog",
  eu_apc_podcannon4_alps: "AMV-2 Groundhog",
  eu_apc_mg: "AMV-2 Groundhog - Mg.",
  eu_apc_mortar: "AMV-2 Groundhog - Mortar",

  as_apc: "BTR-4 Romanov",
  as_apc_second_turret: "BTR-4 Romanov",
  as_apc_podcannon1_base: "BTR-4 Romanov",
  as_apc_podcannon2_base: "BTR-4 Romanov",
  as_apc_podcannon3_base: "BTR-4 Romanov",
  as_apc_podcannon4_base: "BTR-4 Romanov",
  as_apc_pods_alps: "BTR-4 Romanov",
  as_apc_podcannon1_base_pods_alps: "BTR-4 Romanov",
  as_apc_podcannon2_base_pods_alps: "BTR-4 Romanov",
  as_apc_podcannon3_base_pods_alps: "BTR-4 Romanov",
  as_apc_podcannon4_base_pods_alps: "BTR-4 Romanov",
  as_apc_mg: "BTR-4 Romanov - Mg.",
  as_apc_mortar: "BTR-4 Romanov - Mortar",

  eu_tank: "A8 Tiger",
  eu_tank_cupolabase: "A8 Tiger",
  eu_tank_mg: "A8 Tiger - Mg.",

  as_tank: "Type 32 Nekomata",
  as_tank__secondpos: "Type 32 Nekomata",
  as_tank_mg: "Type 32 Nekomata - Mg.",

  eu_fav: "MK-15 Bandit",
  eu_fav_secondposition: "MK-15 Bandit",
  eu_fav_mg: "MK-15 Bandit - Mg.",

  as_fav: "UAZ-8 Ocelot",
  as_fav_secondposition: "UAZ-8 Ocelot",
  as_fav_mg: "UAZ-8 Ocelot - Mg.",

  us_heavy_mech: "L5 Riesig",
  us_heavy_mech_secondaryposition: "L5 Riesig",
  eu_walker: "L5 Riesig",
  eu_walker_mg: "L5 Riesig - Mg.",
  eu_walker_missile: "L5 Riesig - Missile",
  eu_walker_aa: "L5 Riesig - Anti-Air",

  as_heavy_mech: "T39 Bogatyr",
  as_heavy_mech_secondaryposition: "T39 Bogatyr",
  as_walker: "T39 Bogatyr",
  as_walker_mg: "T39 Bogatyr - Mg.",
  as_walker_missile: "T39 Bogatyr - Missile",
  as_walker_aa: "T39 Bogatyr - Anti-air",

  eu_ifv: "A-3 Goliath",
  eu_ifv_grenadelauncherr_base: "A-3 Goliath",
  eu_ifv_machinegunr_base: "A-3 Goliath",
  eu_ifv_grenadelauncherl_base: "A-3 Goliath",
  eu_ifv_machinegunl_base: "A-3 Goliath",
  eu_ifv_mg: "A-3 Goliath - Machinegun",
  eu_ifv_gl: "A-3 Goliath - Rocket",

  as_hov_light: "Type 36 Hachimoto",
  as_hov_light_gunner: "Type 36 Hachimoto",
  as_speeder: "Type 36 Hachimoto",
  as_speeder_gl: "Type 36 Hachimoto - Grenade",
  as_speeder_missile: "Type 36 Hachimoto - Missile",

  eu_pod: "Assault pod",
  eu_pod0: "Assault pod",
  eu_pod_drop: "Assault pod",
  as_pod: "Assault pod",
  pod: "Assault pod",

  static_aa: "Rorsch Kz-27",
  eu_static_aa: "Rorsch Kz-27",
  as_static_aa: "Rorsch Kz-27",

  static_av: "Rorsch Mk-S8",
  eu_static_av: "Rorsch Mk-S8",
  as_static_av: "Rorsch Mk-S8",

  eu_groundcanone3_hub: "MK-1 - Cannon",
  eu_groundcanone3_01_hub: "MK-1 - Cannon",
  eu_groundcanone3_02_hub: "MK-1 - Cannon",
  eu_groundcanone3_03_hub: "MK-1 - Cannon",
  eu_titan_cannon: "MK-1 - Cannon",

  as_groundcanone3_00_hub: "Type 2 Titan - Cannon",
  as_groundcanone3_01_hub: "Type 2 Titan - Cannon",
  as_groundcanone3_02_hub: "Type 2 Titan - Cannon",
  as_groundcanone3_03_hub: "Type 2 Titan - Cannon",
  as_titan_cannon: "Type 2 Titan - Cannon",

  eu_aacannon_hub: "MK-1 - Anti-Air",
  eu_aacannon_01_hub: "MK-1 - Anti-Air",
  eu_titan_aa: "MK-1 - Anti-Air",

  as_aacannon_00_hub: "Type 2 Titan",
  as_aacannon_01_hub: "Type 2 Titan",
  as_titan_aa: "Type 2 Titan",

  // Titan-Basis-Template aus `bf2cc pl` Feld 38 (LIVE verifiziert, Suez): wer
  // auf/im Titan sitzt — Ground-Gun, AA-Gun ODER der vom Titan gestartete Pod —
  // meldet in Feld 38 IMMER `{eu,as}_titan_playtest`; die Engine unterscheidet die
  // Position dort NICHT. Daher der Titan-Name statt des Roh-Strings "titan playtest".
  eu_titan_playtest: "MK-1 Titan",
  as_titan_playtest: "Type 2 Titan",

  uav: "UAV",
  uav_drone_recon: "Squad Drone Recon",
  uav_drone_sentry: "SD-8 Accipiter",
  sentrygun: "A12 Enforcer Sentry Gun",
  lpod: "Launch pod",
  espod: "Escape pod",
  parachute: "PARACHUTE",

  us_heavy_soldier: "",
  pac_heavy_soldier: "",
  as_fav_openposition: "",
  eu_fav_openposition: "",
  as_at_passenger2_left: "",
  as_at_passenger2_right: "",
  as_at_passenger2_left_spawn: "",
  as_at_passenger2_right_spawn: "",
  eu_at_passenger2_left: "",
  eu_at_passenger2_right: "",
  eu_at_passenger2_left_spawn: "",
  eu_at_passenger2_right_spawn: "",
};

/** Waffen-Codes -> Anzeigename. Vorbereitet/exportiert, in Slice B noch nicht UI-verdrahtet. */
export const WEAPON_DISPLAY_NAMES: Record<string, string> = {
  as_sni: "Park 52 Sniper Rifle",
  pac_sniperrifle: "Park 52 Sniper Rifle",

  eu_sni: "Morretti SR4 Sniper Rifle",
  eu_sniperrifle: "Morretti SR4 Sniper Rifle",

  as_ar_rifle: "Krylov FA-37 AR",
  pac_assaultrifle: "Krylov FA-37 AR",

  eu_ar_rifle: "SCAR 11 AR",
  eu_assaultrifle: "SCAR 11 AR",

  as_ar_rocket: "PK-74 AR-Rocket",
  eu_ar_rocket: "PK-74 AR-Rocket",
  pac_assaultrocket: "PK-74 AR-Rocket",
  eu_assaultrocket: "PK-74 AR-Rocket",

  as_ar_shotgun: "Herzog AR-Shotgun",
  eu_ar_shotgun: "Herzog AR-Shotgun",

  as_av: "Sudnik VP",
  eu_av: "Mitchell AV-18 AV",
  eu_anti_vehicle: "Mitchell AV-18 AV",

  as_smg: "Malkov RK-11 SMG",
  pac_smg: "Malkov RK-11 SMG",

  eu_smg: "Turcotte Rapid SMG",

  as_mg: "Shuko LMG",
  pac_lmg: "Shuko LMG",

  eu_mg: "Bianchi LMG",
  eu_lmg: "Bianchi LMG",

  as_handgun: "Takao T20 Pistol",
  pac_pistol: "Takao T20 Pistol",

  eu_handgun: "P33 Pereira Pistol",
  eu_pistol: "P33 Pereira Pistol",

  knife: "BJ-2 Combat Knife",

  unl_carbine: "Lambert Carbine",
  unl_adv_sni: "Zeller-H Advanced Sniper Rifle",

  unl_har_rifle: "Baur H-AR",
  unl_lar_rifle: "Voss L-AR",

  unl_av_rifle: "Pilum H-AVR",
  unl_av: "Pilum H-AVR",

  as_aa: "SAAW 86 Anti-Air",
  eu_aa: "SAAW 86 Anti-Air",

  unl_hmg: "Ganz HMG",

  unl_shotgun: "Clark 15B Shotgun",
  bp1_expl_shotgun: "Clark 12-RDX Shotgun",

  unl_mine_motion: "II-29 Motion Mine",
  unl_mine_antipersonnel: "APM Mine",
  unl_mine_emp: "II-14 EMP Mine",

  unl_grenade_frag: "FRG-1 Grenade",
  unl_grenade_emp: "V5 EMP Grenade",
  unl_grenade_smoke: "SG-34 Smoke Grenade",

  unl_c4: "RDX DemoPak",
  c4_detonator: "C4 Detonator",

  unl_deployer_sentrygun: "A12 Enforcer Sentry Gun",
  eu_sentrygun_firearm: "A12 Enforcer Sentry Gun",

  unl_drone_sentry_detonator: "SD-8 Accipiter",
  unl_drone_sentry_firearm: "SD-8 Accipiter",

  unl_deployer_drone_recon: "Squad Drone Recon",
  unl_drone_recon_firearm: "Squad Drone Recon",

  unl_defibrillator: "AED-6 Defibrillator",
  unl_repair: "HOFF-3000",
  unl_defuser: "AE Defuser",

  unl_hub_medic: "MHUB-21",
  unl_hub_ammo: "AHUB-31",

  unl_beacon: "SLS Beacon",
  unl_sonar: "PDS-1 (Personal Deployed Sonar)",
  sonar: "PDS-1 Sonar",

  unl_active_camo: "IT-33 Active Camouflage",
  unl_pulse_meter: "DysTek Pulse Meter",
  unl_port_shield: "IPS Shield",

  cob: "Commander [Orbital Strike]",
};

/** Gebündelter Zugriff (vehicles/weapons getrennt). */
export const BF2142_DISPLAY_NAMES = {
  vehicles: VEHICLE_DISPLAY_NAMES,
  weapons: WEAPON_DISPLAY_NAMES,
} as const;

const VEHICLE_FACTION_RE = /^(as_|eu_|pac_|us_)/;

/**
 * Optionaler Shortcode+Team-Fallback: ein faktions-loser Stamm (z. B. `ag` aus
 * `eu_ag`/„AG") wird je Team auf den konkreten Engine-Key abgebildet, dessen
 * Anzeigename dann aus `VEHICLE_DISPLAY_NAMES` kommt (eine Quelle der Wahrheit).
 * Beispiel: `AG` + EU -> `us_ag` -> "UD-6 Talon". Team 1 = PAC, sonst = EU.
 */
export const VEHICLE_SHORTCODE_KEYS: Record<string, { eu: string; pac: string }> = {
  ag: { eu: "us_ag", pac: "as_ag" },
  at: { eu: "eu_at", pac: "as_at" },
  apc: { eu: "eu_apc", pac: "as_apc" },
  tank: { eu: "eu_tank", pac: "as_tank" },
  fav: { eu: "eu_fav", pac: "as_fav" },
};

/**
 * Reiner Lookup: exakter Key, dann normalisiert (trim+lowercase). Rückgabe:
 * - der Anzeigename (auch `""`, wenn der Key bewusst nichts anzeigt), oder
 * - `undefined`, wenn der Key nicht im Mapping steht (Aufrufer macht den Roh-Fallback).
 */
export function lookupDisplayName(map: Record<string, string>, raw: string | null | undefined): string | undefined {
  const value = String(raw ?? "").trim();
  if (!value) return undefined;
  if (Object.prototype.hasOwnProperty.call(map, value)) return map[value];
  const lc = value.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(map, lc)) return map[lc];
  return undefined;
}

/**
 * Engine-Vehicle-Code (Feld 38) + Team -> Anzeigename, oder `undefined`, wenn
 * weder ein direkter Key noch ein Shortcode+Team-Fallback greift (Aufrufer macht
 * dann den Roh-Fallback). `""` = bewusst nichts anzeigen.
 */
export function resolveVehicleDisplayName(raw: string | null | undefined, team: 0 | 1 | 2 = 0): string | undefined {
  // 1) exakter / 2) normalisierter Key
  const direct = lookupDisplayName(VEHICLE_DISPLAY_NAMES, raw);
  if (direct !== undefined) return direct;
  // 3) Shortcode (faktions-loser Stamm) + Team -> konkreter Key
  const stem = String(raw ?? "").trim().toLowerCase().replace(VEHICLE_FACTION_RE, "");
  const sc = VEHICLE_SHORTCODE_KEYS[stem];
  if (sc) {
    const mapped = VEHICLE_DISPLAY_NAMES[team === 1 ? sc.pac : sc.eu];
    if (mapped !== undefined) return mapped;
  }
  return undefined;
}
